import { TrackJSErrorPayload } from 'trackjs';

export function trackjsErrorHandler(
  payload: TrackJSErrorPayload,
  error?: Error | undefined
) {
  const excludedUrls = ['/security/authenticate', '/security/verify'];

  return !excludedUrls.some((url) => error?.message.includes(url));
}
